import { X } from 'lucide-react'
import { cn } from '@/shared/lib/utils'
import { Button } from '@/shared/components/ui/button'
import { useAssistantStore } from '../store/assistant-store'
import { AgentSwitcherDropdown } from './agent-switcher-dropdown'
import { UpgradeBadge } from './upgrade-badge'
import type { AgentId } from '../types/assistant'

interface Props {
  agentId: AgentId
  agentName: string
  agentRole: string
  agentColor: string
  agentInitials: string
}

export function AssistantHeader({
  agentId,
  agentName,
  agentRole,
  agentColor,
  agentInitials,
}: Props) {
  const { close } = useAssistantStore()

  return (
    <div className="flex items-center gap-3 px-4 py-3 border-b bg-muted/20 shrink-0">
      <div className="relative shrink-0">
        <div
          className={cn(
            'h-9 w-9 rounded-full flex items-center justify-center text-white text-xs font-bold',
            agentColor,
          )}
        >
          {agentInitials}
        </div>
        <span className="absolute -bottom-0.5 -right-0.5 h-2.5 w-2.5 rounded-full bg-green-500 border-2 border-card" />
      </div>

      <div className="flex-1 min-w-0">
        <div className="flex items-center gap-1.5 flex-wrap">
          <AgentSwitcherDropdown currentAgentId={agentId} agentName={agentName} />
          <UpgradeBadge />
        </div>
        <p className="text-[10px] text-muted-foreground mt-0.5 truncate">{agentRole}</p>
      </div>

      <Button
        size="icon"
        variant="ghost"
        className="h-7 w-7 shrink-0 text-muted-foreground hover:text-foreground"
        onClick={close}
      >
        <X className="h-4 w-4" />
      </Button>
    </div>
  )
}
